<template>
  <div class="ui-content dashboard">
    <div class="create-new-test">
      
    </div>
    <v-card class="mx-auto normal-card">
      <div class="data-table-section CustomizedTest">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
           </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td class="dint-1201">
                    {{ item.test_name }}
                </td>
                <td class="dint-120-test">
                  {{ getFormatedDate(item.created_at) }}
                </td>
                <td class="text-center dint-1201">
                  {{ item.subjects }}
                </td>
                <td class="text-center dint-127">
                  {{ item.duration }}
                </td>
                <td class="dint-120">
                  <div class="cursor_click" @click="onPreviewClick(item)">
                    Preview
                  </div>
                </td>
                <td class="dint-120">
                  <div @click="approveTestPopup(item)" class="Schedule">
                    Approve
                  </div>
                </td>
                <td
                  class="text-center cursor-pointer download-icon"
                  v-if="isAITSInstitute && user && user.role_id === roleIds.TR"
                >
                  <v-img class="loader-img" src="../../../assets/img/loading.gif" v-if="item.status === downloadStatus.IN_PROGRESS"></v-img>
                  <v-btn
                    v-else
                    class="download-btn-cp3"
                    color="transparent"
                    depressed
                    @click="downloadTest(item)"
                  >
                    <v-img
                      width="23px"
                      src="../../../assets/img/download.svg"
                    ></v-img>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";
export default {
  name: "AssignTest",
  data() {
    return {
      orderBy: {
        field: "created_at",
        order: "DESC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      headers: [
        { text: "Test Name", value: "test_name", class: "dint-150" },
        { text: "Created On", value: "created_at", class: "dint-120-test" },
        {
          text: "Subjects",
          value: "subjects",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Duration(mins)",
          align: "center",
          value: "duration",
          class: "text-center dint-120",
          hideSort: true,
        },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
        { text: "", value: "", type: "blank", class: "dint-120" },
	      ],
      items: [],
      dialog: false,
      cComponent: "components/coordinator/Tests/ScheduleTestPopup",
      status: false,
      alertBoxData: {},
      selectedTest: null,
      modalwidth: "1000px",
      instituteType: "SILVER",
      currentTestName: "",
      CONSTANTS_REF: constants,
      downloadStatus: constants.DOWNLOAD_STATUS,
      requestIds: [],
      testStatusTimeout: 0,
      toasts: {},
    };
  },

  mounted() {
    this.getUserDetails();
    if (this.roleIds.ID == this.user.role_id) {
      this.headers.push({
        text: "",
        value: "",
        type: "blank",
        class: "",
      });
    }
  },
  computed: {
    ...mapState("userStore", ["user", "myInstitute"]),
    isAITSInstitute() {
      const instId = (this.myInstitute && this.myInstitute.id)
        ? this.myInstitute.id
        : (JSON.parse(localStorage.getItem("myInstitute")) || {}).id;
      return instId === constants.AITS_INSTITUTE_ID[0];
    }
  },
  methods: {
    ...mapActions({
      getTestList: "testStore/getTestList",
      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
      showLoader: "testStore/showLoader",
      me: "userStore/me",
      updateTestName: "testStore/updateTestName",
      createDuplicateTest: "testStore/createDuplicateTest",
      deleteTestById: "testStore/deleteTestById",
      approveTest: "testStore/approveTest",
    }),
    downloadTest(item) {
      this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
      this.alertBoxData = {
        ...item,
      };
      this.status = true;
      this.modalwidth = "570px";
    },
    confirmDeleteTest(item) {
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.alertBoxData = {
        item,
        message: `Are you sure you want to delete the test - ${item.test_name} ?`,
        refId: "deleteTest",
      };
      this.modalwidth = "350px";
      this.status = true;
      this.$forceUpdate();
    },
    getUserDetails() {
    //   this.me()
    //     .then((response) => {
          this.instituteType = this.user.institute_type;
          this.defaultData();
        // })
        // .catch((err) => {});
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: {
            default: {
              page: 1,
              orderBy: this.orderBy,
            },
          },
        };
        this.setRouteDetails(routeDetails);
      }
    },
    defaultData() {
      this.checkSessionData();
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
      }
      this.requestGetTestList();
    },
    onClose(data) {
      this.status = data.status;
      
      if (data.action === "reloadTestList") {
        this.requestGetTestList();
      }
     
	  if (data.action === "yes" && data.refId === "approveTest") {
        this.approveTests(data.item);
      }

      if (data && data.data) {
        let domainUrl = process.env.VUE_APP_API_URL;
        let token = sessionStorage.getItem("auth_token");
        let api = "download-test";
        let tab = "online";
        const testInstituteId = (data && data.data)
          ? (data.data.test_institute_id || data.data.institute_id)
          : null;
        if (this.isAITSInstitute || testInstituteId === constants.AITS_INSTITUTE_ID[0]) {
          tab = "offline";
        }
        let query = `custom=${tab}&token=${token}&column=${data.isTwoColumn}&isRoughWork=${data.isRoughWork}&pageBreak=${data.pageBreak}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        if (data.download_option === 2) {
          api = "download-answer-key";
          query = `token=${token}`;
        } else if (data.download_option === 3) {
          api = "download-test-solution";
          query = `custom=${tab}&token=${token}&fontSize=${data.bodyFontSize}&fontFamily=${data.bodyFontFamily}&header_alignment=${data.headerAlignment}&header_font_size=${data.headerFontSize}&header_font_family=${data.headerFontFamily}&footer_alignment=${data.footerAlignment}&footer_font_size=${data.footerFontSize}&footer_font_family=${data.footerFontFamily}&watermark=${data.watermark}&opacity=${data.opacity}`;
        } else if (data.download_option === 4) {
          api = "download-omr";
          query = `token=${token}&is_test_id_filled=${data.isTestIDFilled}`;
        }
        if (data.data && data.data.is_test_set == 1) {
          query += `&set_number=${data.selectedSet}`;
        }
        let url = domainUrl + `/test/${api}/${data.data.id}?${query}`;

        if (data.download_option === 2) {
          const currentDateTime = new Date().getTime();
          const testUnlockTime = new Date(data.data.shared_omr_publish_time).getTime();
          if (typeof data.data?.is_shared_test !== 'undefined') {
            window.open(url, "_blank");
          } else {
            if (!(currentDateTime > testUnlockTime)) {
              const unlockText = new Date(testUnlockTime).toLocaleString('en-US');
              this.toasts = this.$toasted.error(
                `You can not download shared test before unlock time ${unlockText}`,
                { icon: "info", duration: null }
              );
              this.toasts.goAway(10000);
            } else {
              window.open(url, "_blank");
            }
          }
        } else {
          this.downloadTestResource(`test/${api}/${data.data.id}?${query}`, data.data);
        }
      }
    },
    downloadTestResource(url, test) {
      this.items.map((item) => {
        if (item.id === test.id) {
          item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS;
        }
      });

      this.downloadTestPaper(url)
        .then((res) => {
          this.items.map((item) => {
            if (item.id === test.id) {
              item.request_id = res.request_id;
            }
          });

          if (!this.requestIds.includes(res.request_id)) {
            this.requestIds.push(res.request_id);
          }

          this.toasts[test.id] = this.$toasted.success(
            "PDF creation under progress. Please do not leave this page",
            { icon: "info", duration: null, id: test.id.toString() }
          );

          this.checkDownloadUpdate();
        })
        .catch((err) => {
          this.items.map((item) => {
            if (item.id === test.id) {
              item.status = constants.DOWNLOAD_STATUS.COMPLETED;
            }
          });
          console.error("Error:", err);
        });
    },
    checkDownloadUpdate() {
      if (this.testStatusTimeout) {
        clearInterval(this.testStatusTimeout);
        this.testStatusTimeout = null;
      }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async (res) => {
          const arr = [];
          this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if (item.url) {
                arr.push({
                  url: data.url,
                  request_id: data.request_id,
                });
              }
              this.requestIds = this.requestIds.filter((rid) => rid !== data.request_id);
              if (this.toasts[item.id]) {
                this.toasts[item.id].goAway(0);
                delete this.toasts[item.id];
              }
              this.$toasted.success(`Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`, { icon: 'info' });
            }
          });
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item);
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve();
              }, 1000);
            });
          }
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {});
    },
    downloadTestURL(item) {
      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };
        setTimeout(() => {
          this.deleteDownloadData(reqData)
            .then((res) => {})
            .catch((err) => {});
        }, 5000);
      }
    },
    onPreviewClick(test) {
      localStorage.setItem("test", JSON.stringify(test));
	  let routeName = this.$route.name;
      localStorage.setItem("previousRoute", routeName);
      localStorage.setItem("previousPath", this.$route.path);

      this.$router.push({
        name: "preview-test",
        params: {
          test_id: test.id,
          test_institute_id: test.test_institute_id,
        },
      });
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    requestGetTestList() {
      if (this.instituteType == this.types.SILVER) return;
      let reqData = {
        test_types: [4],
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
		isAssigned:true
      };

      this.$root.showLoader = true;
      this.getTestList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.items = response.list.map((l) => {
            l.editTestName = false;
            return l;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
      }
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
   
    TestInfoDialog(item) {
      this.selectedTest = item;
      this.cComponent = "components/coordinator/Tests/InstructionsPopup";
      this.modalwidth = "600px";
      this.status = true;
      this.alertBoxData = { selectedTest: this.selectedTest };
      this.$forceUpdate();
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
	approveTests(tests){
		const data = {
			test_id : tests.id
		}
		this.approveTest(data)
			.then(response=>{
				this.$toasted.success(response.message)
				this.requestGetTestList()
			})
			.catch(err => {
				this.$toasted.error("Error Approving test")

			})
	},
	approveTestPopup(item){
		this.cComponent = "components/coordinator/ConfirmationDialog";
		this.alertBoxData = {
			item,
			message: `Are you sure you want to approve this test?`,
			refId: "approveTest",
			};
		this.modalwidth = "350px";
      	this.status = true;
      	this.$forceUpdate()
	}
  },
};
</script>
